<script lang="ts">
	import { PUBLIC_LARGE_PRODUCT_IMAGE } from '$env/static/public';
	import { currencyFormat } from '$lib/utils/formatters';
	import AddToCartButton from '@components/AddToCartButton.svelte';
	import { Step, Stepper } from '@skeletonlabs/skeleton';
	import type { PageData } from './$types';
	import ProductMeasurements from './ProductMeasurements.svelte';

	export let data: PageData;

	const {
		deep,
		description,
		discount,
		high,
		id,
		image_url_0,
		image_url_1,
		image_url_2,
		image_url_3,
		image_url_4,
		image_url_5,
		image_url_6,
		name,
		price,
		weight,
		wide,
		categories
	} = data.product;

	const hasMeasurements = weight || high || wide || deep;

	const allImages = [image_url_0, image_url_1, image_url_2, image_url_3, image_url_4, image_url_5, image_url_6];
	const validImages = allImages.filter((item) => item);
</script>

<section id="product" class="grid gap-8 grid-cols-1 sm:grid-cols-2 mb-16">
	{#if validImages.length === 0}
		<img class="rounded-3xl mx-auto" src="/logo.png" alt="Logo" />
	{:else}
		<Stepper
			regionHeader={validImages.length === 1 ? 'hidden' : ''}
			buttonBack="variant-filled"
			buttonBackLabel="&#60;"
			buttonNextLabel="&#62;"
			buttonCompleteLabel=""
			stepTerm=""
		>
			{#each validImages as image}
				<Step>
					<img class="rounded-3xl mx-auto" src="{PUBLIC_LARGE_PRODUCT_IMAGE}{image}" alt="Imagen del producto" />
				</Step>
			{/each}
		</Stepper>
	{/if}

	<div class="flex flex-col space-y-6">
		{#if categories.length > 0}
			<small class="opacity-80 !-mb-6">{categories.join(', ')}</small>
		{/if}
		<h1 class="h1">{name}</h1>

		<div class="flex space-x-4">
			<h3 class="h3 {discount && 'line-through opacity-70'}">{currencyFormat(price)}</h3>
			{#if discount}
				<h3 class="h3 text-primary-500">
					{currencyFormat(price - price * (discount / 100))}
				</h3>
			{/if}
		</div>

		<p>{description ?? ''}</p>

		{#if hasMeasurements}
			<hr />

			<div class="flex justify-around !mt-4">
				<ProductMeasurements label="Peso" value={weight} type="g." />
				<ProductMeasurements label="Alto" value={high} />
				<ProductMeasurements label="Ancho" value={wide} />
				<ProductMeasurements label="Profundo" value={deep} />
			</div>
		{/if}

		<AddToCartButton {id} {name} {image_url_0} {price} discount={discount ?? 0} class="!mt-16" />
	</div>
</section>

<style>
	:global(#product .step-header) {
		display: none !important;
	}

	:global(#product .stepper-content, #product .step-content, #product .step-navigation) {
		margin: 0;
	}

	:global(#product button:disabled, #product .variant-filled-primary) {
		opacity: 0 !important;
		pointer-events: none;
	}

	:global(#product .step-navigation button) {
		font-size: larger;
	}
</style>
